import AppBar from '@material-ui/core/AppBar';
import Grid from '@material-ui/core/Grid';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import logo from '../assets/savi-logo.svg';
import { breakpointMobile } from './lab/breakpoints';

interface OwnProps {}

interface HeaderProps extends OwnProps, WithStyles<typeof styles> {}

const HeaderBase: FunctionComponent<HeaderProps> = ({ classes }) => (
  <AppBar position="static">
    <Grid
      container
      item
      alignItems="center"
      className={classNames(classes.header)}
    >
      <Grid item>
        <img className={classes.logo} src={logo} />
      </Grid>
    </Grid>
  </AppBar>
);

// styled
const styles = (theme: Theme) => {
  const {
    spacing: { unit: spacing },
  } = theme;
  return createStyles({
    header: {
      [breakpointMobile(theme)]: {
        minHeight: spacing * 7,
      },
      minHeight: spacing * 8,
      paddingLeft: spacing * 3,
      paddingRight: spacing * 3,
      width: '100%',
    },
    logo: {
      maxHeight: 40,
      maxWidth: 190,
    },
  });
};

const enhance = compose<HeaderProps, OwnProps>(
  pure,
  withStyles(styles),
);

/**
 * AppBar header (i.e. with logo)
 */
export const Header = enhance(HeaderBase);

Header.displayName = 'Header';
